import React, { useRef, useState } from 'react';
import "./style.scss";
import { useEffect } from '@wordpress/element';
import { __experimentalLibrary as Library, BlockEditorKeyboardShortcuts, BlockEditorProvider, BlockInspector, BlockList, BlockToolbar, CopyHandler, ObserveTyping, Typewriter, WritingFlow, } from '@wordpress/block-editor';
import { DropZoneProvider, Popover, SlotFillProvider } from '@wordpress/components';
import '@wordpress/format-library';
import '@wordpress/core-data';
/**
 * Internal dependencies
 */
import Grid from '@material-ui/core/Grid';
import { AppBar, LinearProgress, Popover as MuiPopover, Toolbar } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import { registerBlocks } from "@smartfire/gutenberg-react";
import mediaUploadHandler from "./mediaUpload";
import { useGlue } from "../../../../hooks";
const Editor = (props) => {
    const { value, onChange, children = null, header = [React.Fragment], document, documentTitle, sidebar: Sidebar = React.Fragment, settings = {}, } = props;
    const { mediaUpload, uploading } = mediaUploadHandler();
    const addBlockButton = useRef(null);
    const editorWrapper = useRef(null);
    const [addingBlock, setAddingBlock] = useState(false);
    const glue = useGlue();
    settings.__experimentalSetIsInserterOpened = (full) => {
        if (full)
            setAddingBlock(true);
    };
    useEffect(() => {
        registerBlocks();
    }, [registerBlocks]);
    return (React.createElement(React.Fragment, null,
        uploading && React.createElement(LinearProgress, null),
        React.createElement("div", { className: "glue-editor playground" },
            React.createElement(SlotFillProvider, null,
                React.createElement(DropZoneProvider, null,
                    React.createElement(BlockEditorProvider, { value: value, onInput: onChange, onChange: onChange, settings: glue.applyFilter("glue.editor.settings", Object.assign({ mediaUpload, allowedBlockTypes: window.wp.blocks.getBlockTypes().filter(e => e.category !== "smartform").map(e => e.name), imageEditing: false }, settings)) },
                        React.createElement(BlockEditorKeyboardShortcuts, null),
                        React.createElement(Grid, { container: true, className: "editor" },
                            React.createElement(Grid, { xs: 12, item: true },
                                React.createElement(AppBar, { position: "static", color: "default" },
                                    React.createElement(Toolbar, null,
                                        React.createElement(Button, { ref: addBlockButton, variant: "contained", color: "primary", onClick: () => setAddingBlock(!addingBlock) }, "Blocs"),
                                        React.createElement(MuiPopover, { open: addingBlock, anchorEl: addBlockButton.current, onClose: () => setAddingBlock(false), anchorOrigin: {
                                                vertical: 'bottom',
                                                horizontal: 'left',
                                            }, transformOrigin: {
                                                vertical: 'top',
                                                horizontal: 'left',
                                            } },
                                            React.createElement(Library, { showInserterHelpPanel: false, onSelect: () => {
                                                    setAddingBlock(false);
                                                } })),
                                        React.createElement(BlockToolbar, { hideDragHandle: true }),
                                        React.createElement(Grid, { container: true, justifyContent: "flex-end" },
                                            React.createElement(React.Fragment, null, header))))),
                            React.createElement(Grid, { xs: 9, item: true, className: "editor-styles-wrapper view", ref: editorWrapper },
                                React.createElement(Typewriter, null,
                                    React.createElement(CopyHandler, null,
                                        React.createElement(WritingFlow, null,
                                            React.createElement(ObserveTyping, null,
                                                React.createElement(CopyHandler, null,
                                                    children,
                                                    React.createElement(BlockList, null)))))),
                                React.createElement(Popover.Slot, null)),
                            React.createElement(Grid, { xs: 3, item: true, className: "sidebar" },
                                React.createElement(Sidebar, { Document: document, editorWrapperRef: editorWrapper, documentTitle: documentTitle },
                                    React.createElement(BlockInspector, null))))))))));
};
export default Editor;
//# sourceMappingURL=index.js.map